import styled, { css } from 'styled-components';
import { ButtonTag } from '../../components/Button/styles';

export const HotelSearchContainer = styled.article`
  width: 100%;
`;

export const HotelSearchTag = styled.form`
`;

export const HotelSearchFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  padding-top: 0;

  color: ${({ theme }) => theme.black};
  background-color: ${({ theme }) => theme.white};
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(19, 133, 216, 0.2);

  @media(min-width: 768px) {
    align-items: center;
    flex-direction: row;
    padding: 12px;

    border-radius: 50px;
  }
`;

export const HotelRadioListContainer = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;

  border: none;
  overflow-x: scroll;

  @media(min-width: 768px) {
    overflow: visible;
  }
`;

export const HotelRadioList = styled.ul`
  display: flex;
  padding: 15px 0;

  li {
    flex-shrink: 0;

    &:not(:last-child) {
      margin-right: 5px;
    }
  }

  @media(min-width: 768px) {
    li:not(:last-child) {
      margin-right: 5px;
    }
  }
`;

export const HotelRadioLabel = styled.label`
  padding: 5px 15px;
  font-size: 16px;
  line-height: 1;

   background-color: ${({ theme }) => theme.white};
   border-radius: 50px;
  cursor: pointer;

  transition: text-shadow 0.3s, color 0.3s;

  &:hover {
    text-shadow:0 0 1px ${({ theme }) => theme.blue};
    color: ${({ theme }) => theme.blue};
  }

  ${({ isActive, theme }) => isActive && css`
    text-shadow:0 0 1px ${theme.blue};
    color: ${theme.blue};
  `}
`;

export const HotelFields = styled.ul`
  margin-bottom: 10px;

  @media(min-width: 768px) {
    display: flex;
    flex-grow: 1;
    margin-bottom: 0;
  }
`;

export const HotelFieldItem = styled.li`
  position: relative;

  height: 64px;

  &:not(:last-child) {
    border-bottom: 2px solid ${({ theme }) => theme.lightGray};
  }

  & > svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;

    fill: ${({ theme }) => theme.blue};
    stroke: ${({ theme }) => theme.blue};

    pointer-events: none;
  }

  @media(min-width: 768px) {
    width: 33.3333%;
    padding: 0 30px;
    height: auto;

    &:not(:last-child) {
      border-bottom: none;
      border-right: 2px solid ${({ theme }) => theme.lightGray};
    }

    & > svg {
      right: 30px;
    }
  }
`;

export const HotelField = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0;
  padding: 0 10px;
  padding-top: 24px;
  padding-bottom: 20px;
  padding-right: 25px;

  font-size: 16px;
  line-height: 20px;
  text-align: left;

  background-color: transparent;
  border: none;
  outline: none;

  cursor: pointer;

  @media(min-width: 768px) {
    padding-top: 18px;
    padding-bottom: 18px;

    font-size: 18px;
  }
`;

export const HotelFindButton = styled(ButtonTag)`
  span {
    margin-left: 5px;
  }
  
  svg:not(.loader) {
    display: none;
    fill: none;
  }

  &:hover {

    svg:not(.loader) {
      fill: none;
    }
  }

  @media(min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    padding: 0;

    font-size: 0;

    svg:not(.loader) {
      display: block;
    }
  }

  @media(min-width: 1024px) {
    width: auto;
    height: auto;
    padding: 18px 47px;
    font-size: 18px;

    ${({disabled}) => disabled && css`
      padding: 18px 32px;
    `}
    
    span,
    svg:not(.loader) {
      display: none;
    }
  }
`;
